import { Button, Paper, Stack, Typography } from "@mui/material";
import { useState } from "react";
import { Link as RouterLink } from "react-router-dom";

const KEY = "cf.cookie-consent";

export function getCookieConsent(): "all" | "essential" | null {
  try { return (localStorage.getItem(KEY) as "all" | "essential" | null) ?? null; } catch { return null; }
}

export function CookieBanner() {
  const [choice, setChoice] = useState(getCookieConsent());
  if (choice) return null;
  const decide = (v: "all" | "essential") => { try { localStorage.setItem(KEY, v); } catch { /* ignore */ } setChoice(v); };
  return (
    <Paper elevation={6} role="dialog" aria-label="Cookie consent" sx={{ position: "fixed", bottom: 16, left: 16, right: 16, maxWidth: 560, mx: "auto", p: 2, zIndex: 1500 }}>
      <Typography variant="body2" sx={{ mb: 1 }}>We use essential cookies to run the app and optional analytics cookies to improve it. See our <RouterLink to="/cookies">cookie policy</RouterLink>.</Typography>
      <Stack direction="row" spacing={1} justifyContent="flex-end">
        <Button size="small" onClick={() => decide("essential")}>Essential only</Button>
        <Button size="small" variant="contained" onClick={() => decide("all")}>Accept all</Button>
      </Stack>
    </Paper>
  );
}
